export type UserSessionClaims = {
  sessionId: string;
  sessionPolicy: "user-v1";
  sessionExpiresAt: number;
};

// Used for browser behaviour only. The backend verifies the signed token and session.
export const getUserSession = (
  token: string | null
): UserSessionClaims | null => {
  try {
    const encoded = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(
      atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "="))
    );
    return claims.sessionPolicy === "user-v1" &&
      typeof claims.sessionId === "string" &&
      typeof claims.sessionExpiresAt === "number"
      ? claims
      : null;
  } catch {
    return null;
  }
};

export const userActivityKey = (id: string) => `userSessionActivity:${id}`;
